import { render, staticRenderFns } from "./PollOption.vue?vue&type=template&id=61714608&scoped=true&"
import script from "./PollOption.vue?vue&type=script&lang=js&"
export * from "./PollOption.vue?vue&type=script&lang=js&"
import style0 from "./PollOption.vue?vue&type=style&index=0&id=61714608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61714608",
  null
  
)

export default component.exports